import { Turbo } from "@hotwired/turbo-rails"

const showClasses = ["flex"]
const hideClasses = ["hidden"]

Turbo.config.forms.confirm = (message, formElement, submitter) => {
  const dialog = document.querySelector("[data-turbo-confirm-dialog]")

  if (!dialog) return Promise.resolve(window.confirm(message))

  const messageElement = dialog.querySelector("[data-turbo-confirm-message]")
  const descriptionElement = dialog.querySelector("[data-turbo-confirm-description]")
  const cancelButton = dialog.querySelector("[data-turbo-confirm-cancel]")
  const confirmButton = dialog.querySelector("[data-turbo-confirm-submit]")
  const previousActiveElement = document.activeElement
  const description =
    submitter?.dataset.turboConfirmDescription ||
    formElement?.dataset.turboConfirmDescription ||
    ""

  messageElement.textContent = message
  descriptionElement.textContent = description
  descriptionElement.classList.toggle("hidden", description.length === 0)

  return new Promise((resolve) => {
    const close = (answer) => {
      dialog.classList.add(...hideClasses)
      dialog.classList.remove(...showClasses)
      document.body.classList.remove("overflow-hidden")

      dialog.removeEventListener("click", onBackdropClick)
      document.removeEventListener("keydown", onKeydown)
      cancelButton.removeEventListener("click", onCancel)
      confirmButton.removeEventListener("click", onConfirm)

      if (previousActiveElement instanceof HTMLElement) previousActiveElement.focus()

      resolve(answer)
    }

    const onCancel = () => close(false)
    const onConfirm = () => close(true)
    const onBackdropClick = (event) => {
      if (event.target === dialog) close(false)
    }
    const onKeydown = (event) => {
      if (event.key === "Escape") close(false)
    }

    dialog.addEventListener("click", onBackdropClick)
    document.addEventListener("keydown", onKeydown)
    cancelButton.addEventListener("click", onCancel)
    confirmButton.addEventListener("click", onConfirm)

    dialog.classList.remove(...hideClasses)
    dialog.classList.add(...showClasses)
    document.body.classList.add("overflow-hidden")
    confirmButton.focus()
  })
}
